var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsInputBase } from '../_sds-input-base';
import styles from './sds-input-date.lit.scss';
import { DateInputFormatEnforcer } from './date-input-format-enforcer';
import { DatePatternConverter } from './date-pattern-converter';
/**
 * `sds-input-date` is a web component designed for selecting and displaying dates.
 * It provides an input field with customizable formatting options to ensure a consistent
 * user experience when selecting dates.
 *
 * ### Attributes
 * - `format`: The date format to display. Defaults to 'dd/MM/yyyy'.
 * - `format-enforced`: A boolean indicating whether the specified date format is enforced.
 *
 * @tag sds-input-date
 */
let SdsInputDate = (() => {
    var _SdsInputDate_format_accessor_storage, _SdsInputDate_formatEnforced_accessor_storage, _SdsInputDate__input_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-date')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let _format_decorators;
    let _format_initializers = [];
    let _format_extraInitializers = [];
    let _formatEnforced_decorators;
    let _formatEnforced_initializers = [];
    let _formatEnforced_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    var SdsInputDate = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInputDate_format_accessor_storage.set(this, __runInitializers(this, _format_initializers, 'dd/MM/yyyy'));
            _SdsInputDate_formatEnforced_accessor_storage.set(this, (__runInitializers(this, _format_extraInitializers), __runInitializers(this, _formatEnforced_initializers, void 0)));
            _SdsInputDate__input_accessor_storage.set(this, (__runInitializers(this, _formatEnforced_extraInitializers), __runInitializers(this, __input_initializers, void 0)));
            this._dateFormatEnforcer = __runInitializers(this, __input_extraInitializers);
            this._datePatternConverter = new DatePatternConverter(this.format);
            this._calendarOpened = false;
        }
        /**
         * The date format to display.
         * This property allows users to customize how the date is presented.
         *
         * Defaults to 'dd/MM/yyyy'.
         *
         * @attr {string} format - The date format to use for the input.
         */
        get format() { return __classPrivateFieldGet(this, _SdsInputDate_format_accessor_storage, "f"); }
        set format(value) { __classPrivateFieldSet(this, _SdsInputDate_format_accessor_storage, value, "f"); }
        /**
         * Indicates whether the specified date format is enforced.
         * When set to true, the component will ensure that the input adheres to the defined format.
         *
         * @attr {boolean} format-enforced - Indicates if the date format is enforced.
         */
        get formatEnforced() { return __classPrivateFieldGet(this, _SdsInputDate_formatEnforced_accessor_storage, "f"); }
        set formatEnforced(value) { __classPrivateFieldSet(this, _SdsInputDate_formatEnforced_accessor_storage, value, "f"); }
        get _input() { return __classPrivateFieldGet(this, _SdsInputDate__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsInputDate__input_accessor_storage, value, "f"); }
        getInput() {
            return this._input;
        }
        dateSelected(dateStr) {
            if (this.formatEnforced) {
                this.value = this._datePatternConverter.getFormattedDate(dateStr);
                this._dateFormatEnforcer && this._dateFormatEnforcer.setLastValidValue(this.value);
            }
            else {
                this.value = dateStr;
            }
        }
        firstUpdated() {
            this.formatEnforced && this.initDateInputFormatEnforcer();
        }
        handleKeyDown(event) {
            this.formatEnforced && this.formattingOnKeyDown(event);
        }
        handleKeyUp() {
            this.formatEnforced && this.formattingOnKeyUp();
        }
        handleInput() {
            this.formatEnforced && this.formattingOnInput();
        }
        handleFocus() {
            super.handleFocus();
            this.formatEnforced && this.formattingOnFocus();
        }
        handleCalendarOpened() {
            this._calendarOpened = true;
        }
        handleCalendarClosed() {
            this.formatEnforced && !this.focused && this._calendarOpened && this.formattingOnBlur();
            this._calendarOpened = false;
        }
        render() {
            return html `
            <div class="${this.getClasses()}">
                <div class="sds-input__wrapper">
                    ${this.renderInput('text')}${this.renderActionContainer()} ${this.renderDate()}
                </div>

                ${this.renderMessages()}
            </div>
        `;
        }
        renderDate() {
            return html `
            <sds-icon
                class="sds-input__calendar-icon"
                name="calendar_date"
                size="24"
                @click="${() => this.handleFocus()}"
            ></sds-icon>
        `;
        }
        handleBlur() {
            super.handleBlur();
            this.formatEnforced && !this._calendarOpened && this.formattingOnBlur();
        }
        emptyValue() {
            return '';
        }
        convertValue(value) {
            return value;
        }
        handleClear() {
            this.value = this.emptyValue();
            this.dispatchValueCleared();
        }
        formattingOnKeyDown(event) {
            const isOk = this._dateFormatEnforcer.beforeInputCheck(event.key, this._input.selectionStart || 0, this._input.selectionEnd || 0, document.dir.toLowerCase());
            if (!isOk) {
                event.preventDefault();
            }
        }
        formattingOnKeyUp() {
            const dateOption = this._datePatternConverter.checkDateCursor(this._input.selectionStart || 0);
            this.dispatchEvent(new CustomEvent(SdsInputDate.DATE_CURSOR_CHANGE, {
                detail: dateOption,
                bubbles: false,
                composed: false,
            }));
        }
        formattingOnInput() {
            this.getInput().value = this._dateFormatEnforcer.onInput();
            super.handleInput();
            const cursorPos = this._dateFormatEnforcer.getCursorPos();
            this._input.setSelectionRange(cursorPos, cursorPos);
            this._invalidTimeOut && clearTimeout(this._invalidTimeOut);
            this._invalidTimeOut = setTimeout(() => {
                this.invalid = !this._datePatternConverter.isDateValid(this.value);
            }, 3000);
        }
        formattingOnFocus() {
            this._invalidTimeOut = setTimeout(() => {
                this.invalid = !this._datePatternConverter.isDateValid(this.value);
            }, 3000);
            this.placeholder = this.format;
        }
        formattingOnBlur() {
            if (!this._datePatternConverter.isDateValid(this.value)) {
                this.handleClear();
                this._dateFormatEnforcer.resetValue();
            }
            this._invalidTimeOut && clearTimeout(this._invalidTimeOut);
            this.invalid = false;
            this.placeholder = this.format;
        }
        initDateInputFormatEnforcer() {
            const mask = this._datePatternConverter.getMask();
            const currentValue = this._datePatternConverter.getFormattedDate(this.value);
            this._dateFormatEnforcer = new DateInputFormatEnforcer(mask, currentValue);
            this.value = currentValue === mask ? '' : currentValue;
            this.placeholder = this.format;
        }
        dispatchValueCleared() {
            this.dispatchEvent(new CustomEvent(SdsInputDate.INPUT_DATE_CLEAR_EVENT));
        }
    };
    _SdsInputDate_format_accessor_storage = new WeakMap();
    _SdsInputDate_formatEnforced_accessor_storage = new WeakMap();
    _SdsInputDate__input_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputDate");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _format_decorators = [property({ attribute: 'format', type: String })];
        _formatEnforced_decorators = [property({ attribute: 'format-enforced', type: Boolean })];
        __input_decorators = [query('input.sds-input__element')];
        __esDecorate(_classThis, null, _format_decorators, { kind: "accessor", name: "format", static: false, private: false, access: { has: obj => "format" in obj, get: obj => obj.format, set: (obj, value) => { obj.format = value; } }, metadata: _metadata }, _format_initializers, _format_extraInitializers);
        __esDecorate(_classThis, null, _formatEnforced_decorators, { kind: "accessor", name: "formatEnforced", static: false, private: false, access: { has: obj => "formatEnforced" in obj, get: obj => obj.formatEnforced, set: (obj, value) => { obj.formatEnforced = value; } }, metadata: _metadata }, _formatEnforced_initializers, _formatEnforced_extraInitializers);
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputDate = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.INPUT_DATE_CLEAR_EVENT = 'sds.input-date.cleared';
    _classThis.DATE_CURSOR_CHANGE = 'sds.input-date.date-cursor-change';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputDate = _classThis;
})();
export { SdsInputDate };
